/**
 * 停车接口只读适配层。
 *
 * 复制自现有停车查询调用方式（同接口、同请求头），
 * 不复用其他页面模块，避免后续调整影响集团中心。
 * 本文件只有查询，没有新增/修改语义。
 */
import request from '@/utils/request'
import store from '@/store'
import Cookies from 'js-cookie'

const PARKING_URL = '/api/ebc-content/propertyScreen/getParkingManagement'

function buildHeaders () {
  const rawToken = Cookies.get('Admin-Token') || store.getters.token || ''
  const authorization = rawToken
    ? (String(rawToken).startsWith('Bearer ') ? rawToken : `Bearer ${rawToken}`)
    : ''
  return {
    userDeviceType: 'PC',
    'Content-Type': 'application/json',
    authorization,
    'Authorization-UserId': store.state.user.userId,
    'Authorization-UserRole': store.getters.role || (store.getters.roles && store.getters.roles[0]) || ''
  }
}

export function queryParkingManagement ({ startTime, endTime }, transport = request) {
  return transport({
    url: PARKING_URL,
    method: 'post',
    headers: buildHeaders(),
    data: { startTime, endTime },
    skipErrorMessage: true,
    timeout: 60000
  })
}

export function createParkingApi (transport = request) {
  return {
    query (range) {
      return queryParkingManagement({
        startTime: `${range.startDate} 00:00:00`,
        endTime: `${range.endDate} 23:59:59`
      }, transport).then(response => {
        if (!response || String(response.code) !== '200') {
          throw new Error((response && (response.msg || response.error)) || '停车数据请求失败')
        }
        return response
      })
    }
  }
}
